<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <BaseInput
          type="text"
          placeholder="Cari Kode Kantor"
          :shadow="false"
          debounce
          v-model="filter.searchOfficeCode"
          @native-input="loadOrders"
        />
        <BaseInput
          type="text"
          placeholder="Cari Kode Faktur"
          :shadow="false"
          debounce
          v-model="filter.searchOrderCode"
          @native-input="loadOrders"
        />
      </div>
      <Datatable
        :columns="columns"
        :total="orders.meta.page.total"
        :perPage="orders.meta.page.perPage"
        :currentPage="orders.meta.page.currentPage"
        compact
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="order in orders.data"
            :key="order.id"
            :class="[classes.tr, 'cursor-pointer hover:bg-green-100']"
            @click="onDetail(order)"
          >
            <td :class="classes.td">
              {{ order.attributes.origin_code }} /
              {{ order.attributes.destination_code }}
            </td>
            <td :class="classes.td">
              {{ order.attributes.reference_code ?? '-' }}
            </td>
            <td :class="classes.td">
              {{ order.attributes.origin_office_code }} /
              {{ order.attributes.destination_office_code }}
            </td>
            <td :class="classes.td">
              {{ order.attributes.origin_warehouse_code }} /
              {{ order.attributes.destination_warehouse_code }}
            </td>
            <td :class="[classes.td, 'text-center']">
              <BaseBadge
                size="sm"
                :color="
                  order.attributes.order_status === 'Draft' ? 'yellow' : 'blue'
                "
                >{{ order.attributes.order_status }}</BaseBadge
              >
            </td>
          </tr>
        </template>
      </Datatable>
    </div>

    <view-order-log-modal :visible="timelineModal.visible" :order-id="timelineModal.orderId" @close="timelineModal.visible = false" />
  </BaseWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../mixins/request/request';
import ViewOrderLogModal from '../components/order/view-order-log-modal.vue';

export default {
  mixins: [requestMixin],
  components: { ViewOrderLogModal },
  data() {
    return {
      loading: false,
      filter: {
        searchOfficeCode: null,
        searchOrderCode: null,
      },
      orders: {
        data: [],
        meta: {
          page: {},
        },
      },
      timelineModal: {
        visible: false,
        orderId: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    columns() {
      return [
        { id: 'Kode Penjualan', name: 'Kode Penjualan' },
        { id: 'No Faktur', name: 'No Faktur' },
        { id: 'Kode Kantor', name: 'Kode Kantor' },
        { id: 'Kode Gudang', name: 'Kode Gudang' },
        { id: 'Status', name: 'Status', theadClass: 'text-center' },
      ];
    },
  },
  methods: {
    async loadOrders(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/orders`, {
        params: {
          'page[size]': 5,
          'filter[office_code]': this.filter.searchOfficeCode || null,
          'filter[order_code]': this.filter.searchOrderCode,
          'filter[allowed]': true,
          ...params,
        },
      });

      if (!err) {
        this.orders = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
    async onDetail(order) {
      this.timelineModal.orderId = order.attributes.order_id;
      this.timelineModal.visible = true;
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
